<template>
  <footer class="footer">
    <p class="copyright">
      © {{ new Date().getFullYear() }} - Bondue Christophe - {{ $t('rights') }}
    </p>
    <p class="meta">
      {{
        app_name
          ? app_name
          : ''
      }} -
      {{ $t('lastUpdate') }} : v{{ version }} ({{ buildDate }})
    </p>
    <p v-if="authStore.scopes.includes('admin')" class="copyright">
      <a href="#" class="footer-link" @click.prevent="setTheme(currentTheme === 'geek' ? 'rncp37827' : 'geek')">
        Switch to {{ currentTheme === 'geek' ? 'RNCP37827' : 'Geek' }} theme
      </a>
    </p>
  </footer>
</template>

<script setup>
import { ref, computed } from 'vue';
import authApi from '@/axios/authApi';
import { useThemeStore } from '../stores/themeStore';
import { useAuthStore } from '../stores/useAuthStore'
const authStore = useAuthStore();
const { currentTheme, setTheme } = useThemeStore();

import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const version = import.meta.env.VITE_APP_VERSION
const buildDate = import.meta.env.VITE_APP_BUILD_DATE
const app_name = import.meta.env.VITE_APP_NAME

const user = computed(() => {
  const name = authStore.name;
  return name.charAt(0).toUpperCase() + name.slice(1);
});
</script>

<style scoped>
.footer {
  margin-top: 50px;
  text-align: center;
  font-size: 0.95rem;
}

.footer-link {
  color: #00bcd4;
  text-decoration: none;
  font-weight: 600;
}

.footer-link:hover {
  text-decoration: underline;
}

.meta {
  margin-top: 8px;
  font-size: 0.85rem;
  color: #666;
}

.copyright {
  margin-top: 8px;
  font-size: 0.85rem;
  color: #777;
}
</style>
